var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 11.3125H6.4375C5.74714 11.3125 5.1875 11.8721 5.1875 12.5625V15.0625C5.1875 15.7529 5.74714 16.3125 6.4375 16.3125H8.9375C9.62786 16.3125 10.1875 15.7529 10.1875 15.0625V12.5625C10.1875 11.8721 9.62786 11.3125 8.9375 11.3125Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 16.3125C14.6932 16.3125 15.8125 15.1932 15.8125 13.8125C15.8125 12.4318 14.6932 11.3125 13.3125 11.3125C11.9318 11.3125 10.8125 12.4318 10.8125 13.8125C10.8125 15.1932 11.9318 16.3125 13.3125 16.3125Z",
    fill: "#1D4469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69425 10.6879H12.3067C13.263 10.6879 13.813 9.61289 13.2817 8.83789L11.488 6.20664C11.013 5.50664 9.98175 5.50664 9.50675 6.20664L7.713 8.83164C7.18175 9.60664 7.73175 10.6816 8.688 10.6816L8.69425 10.6879Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTask);
export default __webpack_public_path__ + "static/media/DefaultTask.07d6c2546803cef88cd7bbff382030b2.svg";
export { ForwardRef as ReactComponent };